module.exports = __webpack_public_path__ + "static/img/bike.7b55138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bike.png
// module id = +SOA
// module chunks = 20